import __request__ from "routing/request";
export function getThemeOverrides(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.customization/theme", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateThemeOverrides(overrides, is_default, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.customization/theme", overrides, { "is_default": is_default }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteThemeOverrides(delete_default, requestOptions) {
  return __request__("DELETE", "/plugins/org.graylog.plugins.customization/theme", null, { "delete_default": delete_default }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function hasOnlyDefaultThemeOverrides(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.customization/theme/only_defaults_exist", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
